module.exports = __webpack_public_path__ + "fonts/LatoLatin-Regular.1a161b4.ttf";